// @ts-nocheck

import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Settings, Check, X, TestTube } from "lucide-react";

const IntegrationSettingsTab: React.FC = () => {
  // Mock data - this would come from Supabase
  const [integrations, setIntegrations] = useState([
    {
      id: "1",
      service_name: "SendGrid",
      service_type: "email",
      is_active: true,
      config: {
        api_key: "sg-xxx...xxx",
        from_email: "noreply@recruitlook.com",
        from_name: "RecruitLook"
      }
    },
    {
      id: "2",
      service_name: "Twilio",
      service_type: "sms",
      is_active: false,
      config: {
        account_sid: "",
        auth_token: "",
        from_number: ""
      }
    },
    {
      id: "3",
      service_name: "OneSignal",
      service_type: "push",
      is_active: true,
      config: {
        app_id: "xxx-xxx-xxx",
        rest_api_key: "xxx...xxx"
      }
    }
  ]);

  const toggleIntegration = (id: string) => {
    setIntegrations(integrations.map(integration => 
      integration.id === id 
        ? { ...integration, is_active: !integration.is_active }
        : integration
    ));
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4">
        {integrations.map((integration) => (
          <Card key={integration.id}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Settings className="h-5 w-5" />
                  <div>
                    <CardTitle className="text-lg">{integration.service_name}</CardTitle>
                    <p className="text-sm text-muted-foreground capitalize">
                      {integration.service_type} service
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge 
                    variant={integration.is_active ? "default" : "secondary"}
                    className="flex items-center gap-1"
                  >
                    {integration.is_active ? (
                      <>
                        <Check className="h-3 w-3" />
                        Active
                      </>
                    ) : (
                      <>
                        <X className="h-3 w-3" />
                        Inactive
                      </>
                    )}
                  </Badge>
                  <Switch
                    checked={integration.is_active}
                    onCheckedChange={() => toggleIntegration(integration.id)}
                  />
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid gap-4">
                {integration.service_name === "SendGrid" && (
                  <>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="sendgrid-api-key">API Key</Label>
                        <Input
                          id="sendgrid-api-key"
                          type="password"
                          value={integration.config.api_key}
                          placeholder="Enter SendGrid API Key"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="sendgrid-from-email">From Email</Label>
                        <Input
                          id="sendgrid-from-email"
                          value={integration.config.from_email}
                          placeholder="noreply@recruitlook.com"
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="sendgrid-from-name">From Name</Label>
                      <Input
                        id="sendgrid-from-name"
                        value={integration.config.from_name}
                        placeholder="RecruitLook"
                      />
                    </div>
                  </>
                )}

                {integration.service_name === "Twilio" && (
                  <>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="twilio-sid">Account SID</Label>
                        <Input
                          id="twilio-sid"
                          value={integration.config.account_sid}
                          placeholder="Enter Twilio Account SID"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="twilio-token">Auth Token</Label>
                        <Input
                          id="twilio-token"
                          type="password"
                          value={integration.config.auth_token}
                          placeholder="Enter Twilio Auth Token"
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="twilio-from">From Number</Label>
                      <Input
                        id="twilio-from"
                        value={integration.config.from_number}
                        placeholder="+1234567890"
                      />
                    </div>
                  </>
                )}

                {integration.service_name === "OneSignal" && (
                  <>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="onesignal-app-id">App ID</Label>
                        <Input
                          id="onesignal-app-id"
                          value={integration.config.app_id}
                          placeholder="Enter OneSignal App ID"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="onesignal-api-key">REST API Key</Label>
                        <Input
                          id="onesignal-api-key"
                          type="password"
                          value={integration.config.rest_api_key}
                          placeholder="Enter OneSignal REST API Key"
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="flex gap-2 pt-2">
                  <Button variant="outline" size="sm">
                    <TestTube className="h-4 w-4 mr-2" />
                    Test Connection
                  </Button>
                  <Button size="sm">
                    Save Configuration
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default IntegrationSettingsTab;
